import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { Button, FormHelperText, InputLabel } from '@material-ui/core';
import { SecondaryCheckbox, InputText, SecondaryButton, MandatoryField, SimpleField } from '../../../../Core/Controls';
import { getMakeById, postMakeData } from '../../../../Core/Services/InternalUser/makeService';
import { useToast } from '../../../../Core/Hooks/useToast';
import '../../../commonStyle.scss';

const DialogStyle = {
    dialogInput: { width: '100%' },
    mandatoryLabel: { color: 'red' }
};

const VehicleManufacturerModel = (props) => {
    const [btnLoader, setBtnLoader] = useState(false);
    const [state, setState] = useState({
        makeDescription: '',
        makeEscalationContactName: '',
        makeEscalationContactEmail: '',
        makeEscalationContactPhone: '',
        makeActive: true,
        makeLogo: '',
        makeID: null,
        errors: {}
    });

    const { showToastSuccess, showToastError } = useToast();

    useEffect(async () => {
        if (props.makeID) {
            let res = await getMakeById(props.makeID);
            if (res.success) {
                setState((state) => ({
                    ...state,
                    makeID: res.data.makeID,
                    makeDescription: res.data.makeDescription,
                    makeEscalationContactName: res.data.makeEscalationContactName,
                    makeEscalationContactEmail: res.data.makeEscalationContactEmail,
                    makeEscalationContactPhone: res.data.makeEscalationContactPhone,
                    makeActive: res.data.makeActive,
                    makeLogo: res.data.makeLogo
                }));
            } else {
                showToastError(res.message);
            }
        }
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setState((state) => ({ ...state, [name]: value }));
    };

    const handleCheckbox = (e) => {
        const { name, checked } = e.target;
        setState((state) => {
            const nst = { ...state, [name]: checked };
            return nst;
        });
    };

    let handleImage = (event) => {
        let reader = new FileReader();
        reader.onload = (e) => {
            const { result } = e.target;
            setState((state) => {
                const nst = { ...state, makeLogo: result };
                return nst;
            });
        };
        reader.readAsDataURL(event.target.files[0]);
    };

    const clearImage = () => {
        if (state.makeLogo) {
            setState((st) => ({ ...st, makeLogo: null }));
        }
    };

    const validations = () => {
        const { makeDescription } = state;
        let formIsValid = true;
        let errors = {};
        if (!makeDescription) {
            errors.makeDescription = 'Description is required';
            formIsValid = false;
        }
        setState((state) => ({ ...state, errors: errors }));
        return formIsValid;
    };

    const submitHandler = async () => {
        if (validations()) {
            setBtnLoader(true);
            const makeData = {
                makeID: state.makeID,
                makeDescription: state.makeDescription,
                makeEscalationContactName: state.makeEscalationContactName,
                makeEscalationContactEmail: state.makeEscalationContactEmail,
                makeEscalationContactPhone: state.makeEscalationContactPhone,
                makeLogo: state.makeLogo,
                makeActive: state.makeActive
            };
            let res = await postMakeData(makeData);
            setBtnLoader(false);
            if (res.success) {
                showToastSuccess(res.message);
                props.onClose(true);
            } else {
                showToastError(res.message);
                // props.onClose(false);
            }
        }
    };

    return (
        <Grid container direction="row" spacing={2} justify="center" alignItems="center">
            <Grid item xs={12} className="mandatory-fields">
                <MandatoryField
                    inputLabel="Description"
                    name="makeDescription"
                    value={state.makeDescription}
                    onChange={handleInputChange}
                    errors={state.errors.makeDescription}
                    autoFocus={true}
                />
            </Grid>
            <Grid item xs={12}>
                <SimpleField
                    inputLabel="Contact Name"
                    name="makeEscalationContactName"
                    value={state.makeEscalationContactName}
                    onChange={handleInputChange}
                    // errors={state.errors.makeEscalationContactName}
                    inputProps={{ maxLength: 50 }}
                />
            </Grid>
            <Grid item xs={12}>
                <SimpleField
                    inputLabel="Contact Email"
                    name="makeEscalationContactEmail"
                    value={state.makeEscalationContactEmail}
                    onChange={handleInputChange}
                    // errors={state.errors.makeEscalationContactEmail}
                    inputProps={{ maxLength: 128 }}
                />
            </Grid>
            <Grid item xs={12}>
                <SimpleField
                    inputLabel="Contact Phone"
                    name="makeEscalationContactPhone"
                    value={state.makeEscalationContactPhone}
                    onChange={handleInputChange}
                    // errors={state.errors.makeEscalationContactPhone}
                    inputProps={{ maxLength: 20 }}
                />
            </Grid>
            <Grid item xs={12}>
                <InputLabel shrink>Logo </InputLabel>
                {state.makeLogo ? (
                    <SecondaryButton
                        onClick={clearImage}
                        style={{
                            width: '25%',
                            textTransform: 'capitalize'
                        }}
                    >
                        Remove Logo
                    </SecondaryButton>
                ) : (
                    <input type="file" name="makeLogo" onChange={handleImage} accept="image/*" />
                )}
            </Grid>
            <Grid item xs={12}>
                <SecondaryCheckbox checked={state.makeActive} name="makeActive" onChange={handleCheckbox} label="Is Active ?" />
            </Grid>
            <Grid item xs={12} className="submit_btn">
                <SecondaryButton isBtnLoader={btnLoader} onClick={submitHandler}>
                    {props.makeID ? 'Update' : 'Add'}
                </SecondaryButton>
            </Grid>
        </Grid>
    );
};

export default VehicleManufacturerModel;
